import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import PersonalDetails from './PersonalDetails';
import AboutYourself from './AboutYourself';
import ConnectSocialMedia from './ConnectSocialMedia';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import StepConnector from '@material-ui/core/StepConnector';

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 15,
  },
  active: {
    '& $line': {
      borderTop: '2px solid #febd1c',
    },
  },
  completed: {
    '& $line': {
      borderTop: '2px solid #febd1c',
    },
  },
  line: {
    height: 3,
    borderTop: '2px dashed #cbd0dd',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#e3e7f0',
    zIndex: 1,
    color: '#9aa3b8',
    width: 32,
    height: 32,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 13,
    fontWeight: 'bold',
    transition: 'all .2s ease',
  },
  active: {
    background: '#111936',
    color: '#fff',
    boxShadow: '0px 0px 0px 4px rgba(254, 189, 28, 0.28)',
  },
  completed: {
    background: '#febd1c',
    color: '#111936',
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: '1',
    2: '2',
    3: '3',
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {completed ? '✓' : icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Profile Details', 'About Yourself', 'Connect Social Media'];
}

function getStepContent(stepIndex, handleNext) {
  switch (stepIndex) {
    case 0:
      return <PersonalDetails handleNext={handleNext} />;
    case 1:
      return <AboutYourself handleNext={handleNext} />;
    case 2:
      return <ConnectSocialMedia />;
    default:
      return '';
  }
}

export default function HorizontalLabelPositionBelowStepper() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleSkip = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };


  return (
    <div className={classes.root}>
      <div className="ps-stepper">
        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
          {steps.map((label, i) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                <span
                  style={{
                    fontSize: 12,
                    color: i <= activeStep ? '#111936' : '#8a90a0',
                    fontWeight: i <= activeStep ? 700 : 500,
                  }}
                >
                  {label}
                </span>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      <div className="ps-form">
        {getStepContent(activeStep, handleNext)}
        {activeStep === 1 ? (
          <span onClick={handleSkip} className="ps-skip">
            Skip this step
          </span>
        ) : null}
      </div>
    </div>
  );
}
